import React from 'react'

const Errors = ({errors}) => {
    if (!errors) return null
    const keys= Object.keys(errors)
    return (
        <>
          { keys.map((field) => {
              return <><b>{field}</b>: {errors[field].join(', ')}<br /> </>
            })
          }  
        </>
    )
}

export default Errors
